module.exports = __webpack_public_path__ + "static/media/main-image.cef1bb4d.png";